import BaseItem, { Rarity } from './base_item';

export default class Navigator extends BaseItem {
    constructor(x, y) {
        super(x, y, "items", "handwheel.png");
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 15; }
    static get height() { return 8; }

    static get mass() { return 5; }
    static get electronic() { return true; }
    static get rarity() { return Rarity.RARE; }


    static get type() { return 'handwheel' }
    static get label() { return 'handwheel' }
    static get description() {
        return `It's a handwheel. The best thing for drying your socks on.`}
}


// WEBPACK FOOTER //
// ./src/objects/items/handwheel.js